export default "__VITE_ASSET__CJ1jkV3e__"